module.exports = __webpack_public_path__ + "img/initiative_ac2.3ac4bb50.jpg";